import { PolicyGuard } from '@/components/guards/PolicyGuard'
import { IMPLEMENTED_REPORT_PAGES } from '../constants/reportPageRegistry'
import { ReportPlaceholderPage } from '../pages/ReportPlaceholderPage'

export function ReportListRoute({
  path,
  policies,
  label,
}: {
  path: string
  policies: string[]
  label: string
}) {
  const Page = IMPLEMENTED_REPORT_PAGES[path]
  return (
    <PolicyGuard requiredPolicies={policies}>
      {Page ? <Page /> : <ReportPlaceholderPage title={label} />}
    </PolicyGuard>
  )
}
